import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function enumToPgEnum<T extends Record<string, any>>(
  myEnum: T
): [keyof T] {
  return Object.values(myEnum).map((value: any) => `${value}`) as any;
}

export function truncateString(str: string, length: number = 40): string {
  if (str.length > length) return str.trim().substring(0, length) + "...";
  return str.trim();
}
